// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-card{display:flex;align-items:center;padding:10px;margin-bottom:10px;background-color:rgba(252,116,116,.15);border:1px solid #a72b2b}.warning-card.resolved{background-color:rgba(116,192,252,.15);border-color:rgba(116,192,252,.45)}.warning-card-left{flex:1;margin-right:10px}.warning-card-dp{font-weight:bold;text-decoration:underline;color:blue;cursor:pointer}.warning-card-message{font-size:14px;font-style:italic}", ""]);
// Exports
module.exports = exports;
